var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-main',{attrs:{"tableData":_vm.tableData,"loading":_vm.loading,"disabled":_vm.disabled},on:{"reload":_vm.getData}})}
var staticRenderFns = []

export { render, staticRenderFns }